import { getBaliDateKey, toBaliDateKey } from '@/lib';

interface BirthdayNotificationProps {
  firstName: string;
  dateOfBirth: string | null | undefined;
}

export default function BirthdayNotification({ firstName, dateOfBirth }: BirthdayNotificationProps) {
  // Check if birthday is today (Bali time). Compare the MM-DD of today's Bali
  // date key against the stored DOB's MM-DD — no Date/timezone conversion, which
  // otherwise shifts a date-only DOB a day for admins outside WITA.
  const isBirthdayToday = (() => {
    if (!dateOfBirth) return false;
    const dobKey = toBaliDateKey(dateOfBirth);
    if (!dobKey) return false;
    return getBaliDateKey(new Date()).slice(5) === dobKey.slice(5);
  })();

  if (!isBirthdayToday) return null;

  return (
    <div className="bg-red-100 border-2 border-red-400 rounded-lg p-4 flex items-center gap-3">
      <span className="text-4xl flex-shrink-0">🎂</span>
      <div>
        <div className="font-bold text-red-800 text-lg">Birthday Today!</div>
        <div className="text-red-700 text-sm">
          Please congratulate {firstName} on their special day!
        </div>
      </div>
    </div>
  );
}
